import { MutationTree } from 'vuex';
import { FeedbackStateI } from './state';

export const mutations: MutationTree<FeedbackStateI> = {};
